/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import { CoachChat } from 'bundles/ai-coach-platform/components/patterns';
import { ChatEmptyState } from 'bundles/ai-coach-platform/components/patterns/chat/common';
import CoachChatFooter from 'bundles/search-common/components/experiments/aiSearchOnLohp/CoachChatFooter';
import CourseraAiMessage from 'bundles/unified-common/components/coach-on-discovery/CourseraAiMessage';
import CourseraAiMessageLoader from 'bundles/unified-common/components/coach-on-discovery/CourseraAiMessageLoader';
import CourseraAiTemporaryStreamedMessage from 'bundles/unified-common/components/coach-on-discovery/CourseraAiTemporaryStreamedMessage';
import FullScreenCoachChatContainer from 'bundles/unified-common/components/coach-on-discovery/FullScreenCoachChatContainer';
import MinimizedCoachChatHeader from 'bundles/unified-common/components/coach-on-discovery/MinimizedCoachChatHeader';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';

import _t from 'i18n!nls/search-common';

const styles = {
  coachChat: css`
    padding: 0;

    .coach-message-client {
      display: flex;
      align-items: flex-end;
    }
  `,
  minimizedChatContainer: css`
    background: var(--cds-color-neutral-background-primary);
    border-top-left-radius: var(--cds-border-radius-200);
    border-top-right-radius: var(--cds-border-radius-200);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3001;
    box-shadow: 0 0 28px -6px rgb(0 0 0 / 16%), 0 0 28px -12px rgb(0 0 0 / 16%);
    transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
    width: 300px;
    height: 52px;

    ${breakpoints.down('xs')} {
      width: 100%;
      border-radius: 0;
    }
  `,
};

const CoachChatContainer = () => {
  const { coachOpen, contextConfig } = useCoachState();
  const displayTitle = _t('Hi, learner!');
  const displaySubtitle = _t('How can I help?');

  const minimizedChat = (
    <div css={styles.minimizedChatContainer}>
      <MinimizedCoachChatHeader />
    </div>
  );

  return (
    <React.Fragment>
      {coachOpen && (
        <FullScreenCoachChatContainer minimizedChat={minimizedChat}>
          <CoachChat
            additionalStyles={styles.coachChat}
            aria-label={_t('Ask Coursera chat container')}
            inputLabel={_t('Ask Coursera')}
            chatMessageListAriaLabel={_t('Ask Coursera chat messages')}
            showSettings={false}
            mode={contextConfig.config.coachModeId}
            contextConfig={contextConfig}
            storeSessionId={true}
            emptyState={<ChatEmptyState title={displayTitle} subtitle={displaySubtitle} />}
            customHeader={<MinimizedCoachChatHeader />}
            renderCustomMessage={(props) => <CourseraAiMessage {...props} />}
            renderCustomMessageLoader={(props) => <CourseraAiMessageLoader {...props} />}
            renderCustomTemporaryStreamedMessage={(props) => <CourseraAiTemporaryStreamedMessage {...props} />}
            customFooter={<CoachChatFooter />}
            enableTextStreaming={true}
            enableLoggedOutMode={true}
          />
        </FullScreenCoachChatContainer>
      )}
    </React.Fragment>
  );
};

export default CoachChatContainer;
